const CERTAINTY_LEVEL = Object.freeze({
  UNAVAILABLE: 'unavailable',
  UNPROCESSED: 'unprocessed',
  UNSURE: 'unsure',
  PROCESSED: 'processed',
  PERFECT: 'perfect',
});

export { CERTAINTY_LEVEL };
